import React from 'react';

interface LoadingProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  color?: 'primary' | 'secondary' | 'white' | 'gray';
  text?: string;
  fullPage?: boolean;
  className?: string;
}

const Loading: React.FC<LoadingProps> = ({
  size = 'md',
  color = 'primary',
  text,
  fullPage = false,
  className = '',
}) => {
  // Size styles
  const sizeStyles = {
    xs: 'h-4 w-4',
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16',
  };
  
  // Color styles
  const colorStyles = {
    primary: 'text-red',
    secondary: 'text-blue',
    white: 'text-white',
    gray: 'text-text-tertiary',
  };
  
  // Combine spinner styles
  const spinnerClassName = `animate-spin ${sizeStyles[size]} ${colorStyles[color]} ${className}`;
  
  // Spinner SVG
  const spinner = (
    <svg className={spinnerClassName} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
  );
  
  // Full-page loading
  if (fullPage) {
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center bg-background-primary dark:bg-background-secondary bg-opacity-75 dark:bg-opacity-75 z-50">
        {spinner}
        {text && <p className="mt-4 text-text-secondary dark:text-text-primary text-center">{text}</p>}
      </div>
    );
  }
  
  // Regular loading spinner
  return (
    <div className="flex flex-col items-center justify-center">
      {spinner}
      {text && <p className="mt-2 text-text-secondary dark:text-text-primary text-center text-sm">{text}</p>}
    </div>
  );
};

export default Loading;